import { render, staticRenderFns } from "./TheAdminNavbarVertical.vue?vue&type=template&id=3ae23104&"
import script from "./TheAdminNavbarVertical.vue?vue&type=script&lang=js&"
export * from "./TheAdminNavbarVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports